const unit = (dx, dy) => {
  const d = Math.hypot(dx, dy) || 1;
  return [dx / d, dy / d];
};

export function resolveAnchor(anchor, pos, ball, cfg) {
  const { bases, ready } = cfg;
  const [bx, by] = ball;
  switch (anchor.type) {
    case "ball":
      return ball;
    case "ready":
      return ready[pos];
    case "base":
      return bases[anchor.base];
    case "line": {
      const [tx, ty] = bases[anchor.to];
      if (anchor.dist != null) {
        const [ux, uy] = unit(bx - tx, by - ty);
        return [tx + ux * anchor.dist, ty + uy * anchor.dist];
      }
      return [bx + (tx - bx) * anchor.t, by + (ty - by) * anchor.t];
    }
    case "backup": {
      const [sx, sy] = anchor.from === "ball" ? ball : bases[anchor.from];
      const [px, py] = bases[anchor.base];
      const [ux, uy] = unit(px - sx, py - sy);
      return [px + ux * anchor.dist, py + uy * anchor.dist];
    }
    case "behind": {
      const [ux, uy] = unit(bx, by);
      return [bx + ux * anchor.dist + uy * anchor.side * anchor.off, by + uy * anchor.dist - ux * anchor.side * anchor.off];
    }
    case "toward": {
      const [rx, ry] = ready[pos];
      const [tx, ty] = bases[anchor.to];
      return [rx + (tx - rx) * anchor.t, ry + (ty - ry) * anchor.t];
    }
    default:
      return ready[pos];
  }
}

export function resolvePlayers(play, ball, cfg) {
  const out = {};
  play.players.forEach((p) => {
    out[p.pos] = { ...p, pt: p.anchor ? resolveAnchor(p.anchor, p.pos, ball, cfg) : [p.x, p.y] };
  });
  return out;
}

const deg = (x, y) => (Math.atan2(x, y) * 180) / Math.PI;

export function classifyHit([x, y], cfg, hitType) {
  const { base: B, mound: M, fence: F } = cfg;
  const r = Math.hypot(x, y);
  const ang = deg(x, y);
  if (y <= 0 || Math.abs(ang) > 45) return { foul: true, ball: [x, y] };
  let ball = r > F * 0.98 ? [(x / r) * F * 0.98, (y / r) * F * 0.98] : [x, y];
  if (hitType === "bunt") {
    const max = B * 0.45;
    if (r > max) ball = [(x / r) * max, (y / r) * max];
    const br = Math.hypot(ball[0], ball[1]);
    const fielder = br < B * 0.18 ? "C" : ang < -12 ? "3B" : ang > 12 ? "1B" : "P";
    return { foul: false, ball, fielder };
  }
  if (r > B * 1.65) return { foul: false, ball, fielder: ang < -15 ? "LF" : ang > 15 ? "RF" : "CF" };
  if (hitType === "fly" && r < B * 0.3) return { foul: false, ball, fielder: "C" };
  if (Math.hypot(x, y - M) < B * 0.2) return { foul: false, ball, fielder: "P" };
  const fielder = ang < -27 ? "3B" : ang < -2 ? "SS" : ang < 25 ? "2B" : "1B";
  return { foul: false, ball, fielder };
}
